import { render, staticRenderFns } from "./AISMap.vue?vue&type=template&id=87b255bc&scoped=true&"
import script from "./AISMap.vue?vue&type=script&lang=js&"
export * from "./AISMap.vue?vue&type=script&lang=js&"
import style0 from "./AISMap.vue?vue&type=style&index=0&id=87b255bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b255bc",
  null
  
)

export default component.exports